import { render, staticRenderFns } from "./FuturePlans.vue?vue&type=template&id=e2e58858&"
import script from "./FuturePlans.vue?vue&type=script&lang=js&"
export * from "./FuturePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports